import React from "react";
import {Loadable} from "@assecobs/react-common-components/index";
import {Icon} from "@assecobs/react-common-components/index";
import {I18nMessage} from "assecobs-faktor-web-common/index";
import classnames from "classnames";
import _ from "lodash";
import AppLogo from "assecobs-faktor-web-profile/AppLogo";
import MessageType from "../common/MessageType";
import Dropdown from '../containers/dropdown/Dropdown';

const MessageBox = ({msg}) => {
    if (msg && msg.text) {

        let messages = _.isString(msg.text) ? msg.text.split(/\\n/) : msg.text;

        const alertElement = _.isArray(messages) ? messages.map((item, key) => {
            return <span key={key}>{item}<br/></span>
        }) : <span>{messages}</span>;

        return (
            <div className={classnames("alert abs-alert", {
                "alert-info": _.isEqual(msg.type, MessageType.INFO),
                "alert-danger": _.isEqual(msg.type, MessageType.ERROR)
            })} role="alert">
                {alertElement}
            </div>
        )
    }

    return null;
};

export default ({title, subtitle, icon, submitting, children, msg, className, isLanguage = false}) => (
    <div className={classnames("login-container container-fluid", className)}>
        <div className="login-box login-box-fw">
            <Loadable loading={submitting} transparent className="login-box-panel login-box-panel-loader">
                <div className="login-box-panel-content">
                    <div className="login-box__title-container">
                        {isLanguage && <Dropdown/>}
                        {icon && <Icon name={icon} />}
                        {title && <h1 className="login-box__title"><I18nMessage id={title}/></h1>}
                        {subtitle && <h3 className="login-box__subtitle"><I18nMessage id={subtitle} /></h3>}
                    </div>
                    {children}
                </div>
            </Loadable>
        </div>
        <div className="login-box-mobile login-box-mobile-fw"></div>

        <div className="col-sm-12">
            <AppLogo/>
            <a href="http:\\assecobs.pl" title="Asseco Business Solutions">
                <svg className="logo-right" dataname="www (do svg)" xmlns="http://www.w3.org/2000/svg" width="72.47" height="12.75" viewBox="0 0 72.47 12.75">

                    <path id="assecobs" fill="#000000" className="cls-1"
                          d="M1130.5,592.4a2.51,2.51,0,0,0,2.74,2.45,2.3,2.3,0,0,0,1.78-.658l0.13,0.476h1.7v-4.633c0-1.638-.7-2.869-3.05-2.869a5.452,5.452,0,0,0-2.88.867l0.73,1.316a4.294,4.294,0,0,1,1.94-.518,1.125,1.125,0,0,1,1.33,1.078v0.476a2.948,2.948,0,0,0-1.58-.406C1131.63,589.977,1130.5,590.957,1130.5,592.4Zm1.93-.056a1.3,1.3,0,1,1,1.28,1.008A1.125,1.125,0,0,1,1132.43,592.342Zm8.09,2.506c1.59,0,2.82-.9,2.82-2.324,0-2.617-3.47-2.057-3.47-3.219a0.639,0.639,0,0,1,.75-0.588,1.667,1.667,0,0,1,1.32.7l1.27-.952a2.8,2.8,0,0,0-2.5-1.3c-1.5,0-2.66.811-2.66,2.169,0,2.6,3.45,2.17,3.45,3.289a0.737,0.737,0,0,1-.89.658,2.076,2.076,0,0,1-1.68-.8l-1.14,1.008A3.142,3.142,0,0,0,1140.52,594.848Zm6.09,0c1.59,0,2.82-.9,2.82-2.324,0-2.617-3.47-2.057-3.47-3.219a0.639,0.639,0,0,1,.75-0.588,1.667,1.667,0,0,1,1.32.7l1.27-.952a2.8,2.8,0,0,0-2.5-1.3c-1.5,0-2.66.811-2.66,2.169,0,2.6,3.45,2.17,3.45,3.289a0.737,0.737,0,0,1-.89.658,2.076,2.076,0,0,1-1.68-.8l-1.14,1.008A3.142,3.142,0,0,0,1146.61,594.848Zm3.46-3.821a3.653,3.653,0,0,0,3.85,3.821,3.477,3.477,0,0,0,3.08-1.61l-1.27-.966a2.149,2.149,0,0,1-1.78.9,1.772,1.772,0,0,1-1.9-1.679h5.15c0.01-.14.01-0.28,0.01-0.42,0-2.394-1.29-3.9-3.55-3.9A3.62,3.62,0,0,0,1150.07,591.027Zm2.03-.8a1.554,1.554,0,0,1,1.58-1.484,1.5,1.5,0,0,1,1.57,1.484h-3.15Zm9.8,2.911a2.137,2.137,0,0,1-.07-4.269,2.484,2.484,0,0,1,1.71.7l0.54-1.624a3.7,3.7,0,0,0-2.3-.783,3.779,3.779,0,0,0-3.9,3.863,3.858,3.858,0,0,0,6.19,3.037l-0.52-1.582A2.65,2.65,0,0,1,1161.9,593.14Zm2.84-2.113a3.942,3.942,0,0,0,7.88,0A3.941,3.941,0,0,0,1164.74,591.027Zm1.94,0a2.01,2.01,0,1,1,4.01,0A2.008,2.008,0,1,1,1166.68,591.027Zm7.05,3.639h1.82V593.91a2.848,2.848,0,0,0,2.17.938,3.56,3.56,0,0,0,3.58-3.835c0-2.268-1.37-3.849-3.47-3.849a2.758,2.758,0,0,0-2.17.951v-3.569h-1.93v10.12Zm1.88-3.639a1.907,1.907,0,0,1,1.87-2.156,1.934,1.934,0,0,1,1.88,2.156,1.9,1.9,0,0,1-1.88,2.113A1.921,1.921,0,0,1,1175.61,591.027Zm9.04,3.821c1.58,0,2.81-.9,2.81-2.324,0-2.617-3.47-2.057-3.47-3.219a0.648,0.648,0,0,1,.76-0.588,1.646,1.646,0,0,1,1.31.7l1.28-.952a2.81,2.81,0,0,0-2.51-1.3c-1.49,0-2.66.811-2.66,2.169,0,2.6,3.46,2.17,3.46,3.289a0.742,0.742,0,0,1-.9.658,2.07,2.07,0,0,1-1.67-.8l-1.14,1.008A3.128,3.128,0,0,0,1184.65,594.848Z"
                          transform="translate(-1130.5 -584.531)"></path>
                    <path id="suffix" dataname=".pl"
                          d="M1189.87,594.848a1.178,1.178,0,0,0,1.19-1.176,1.19,1.19,0,1,0-2.38,0A1.178,1.178,0,0,0,1189.87,594.848Zm2.48,2.435h1.93V593.91a2.788,2.788,0,0,0,2.17.938c2.1,0,3.47-1.582,3.47-3.849a3.567,3.567,0,0,0-3.58-3.835,2.8,2.8,0,0,0-2.17.951v-0.769h-1.82v9.937Zm1.88-6.3a1.893,1.893,0,1,1,1.87,2.155A1.915,1.915,0,0,1,1194.23,590.985Zm6.81,3.681h1.93v-10.12h-1.93v10.12Z"
                          transform="translate(-1130.5 -584.531)"></path>
                </svg>
            </a>
        </div>

        <div className="message-box-container">
            <MessageBox msg={msg}/>
        </div>
    </div>
);
